import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from "flarum/forum/app";
import Modal from "flarum/common/components/Modal";
import Button from "flarum/common/components/Button";
import Avatar from "flarum/common/components/Avatar";
import Switch from "flarum/common/components/Switch";
import username from "flarum/common/helpers/username";
import classList from "flarum/common/utils/classList";
import userLink from "../utils/userLink";
import { NotificationLevel } from "../../common/models/Channel";
import chatState from "../state/chat";
import { isOnline } from "../utils/presence";
import { MembersSkeleton } from "./Skeletons";
import { channelIcon } from "../utils/channelIcon";
import { sendKeyPreference } from "../utils/shortcuts";
import AddMembersModal from "./AddMembersModal";
/**
 * Channel details: notification preferences, the member list, and the moderation
 * actions that change a channel's state.
 *
 * Distinct from ChannelFormModal, which edits what a channel *is* (name, category,
 * threading) and needs the edit permission. This is what any member may see and
 * adjust for themselves, with the state-changing actions gated per capability
 * flag — so a plain member gets a useful panel rather than a locked one.
 */
export default class ChannelInfoModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "tab", "settings");
    _defineProperty(this, "members", []);
    _defineProperty(this, "loadingMembers", false);
    _defineProperty(this, "loadedMembers", false);
    _defineProperty(this, "memberFilter", "");
    _defineProperty(this, "working", false);
  }
  className() {
    return "ChatModal ChatChannelInfoModal Modal--medium";
  }
  title() {
    const channel = this.attrs.channel;
    return m('[', null, m("span", {
      className: "ChatChannelInfo-icon"
    }, channelIcon(channel)), channel.displayName());
  }
  content() {
    return m("div", {
      className: "ChatChannelInfo"
    }, m("div", {
      className: "ChatChannelInfo-tabs"
    }, this.tabButton("settings", "ramon-chat.forum.info.tab_settings"), this.tabButton("members", "ramon-chat.forum.info.tab_members")), this.tab === "settings" ? this.settings() : this.memberTab());
  }
  tabButton(tab, key) {
    return m("button", {
      type: "button",
      className: classList("ChatChannelInfo-tab", {
        "ChatChannelInfo-tab--active": this.tab === tab
      }),
      onclick: () => {
        this.tab = tab;
        if (tab === "members") this.loadMembers();
      }
    }, app.translator.trans(key));
  }

  // ── Settings tab ───────────────────────────────────────────────────────────

  settings() {
    var _channel$notification;
    const channel = this.attrs.channel;
    return m("div", null, channel.description() ? m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-section-label"
    }, app.translator.trans("ramon-chat.forum.info.description")), m("div", null, channel.description())) : null, m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-section-label"
    }, app.translator.trans("ramon-chat.forum.info.notifications")), m("label", null, app.translator.trans("ramon-chat.forum.info.notification_level"), m("select", {
      className: "FormControl",
      value: String((_channel$notification = channel.notificationLevel()) != null ? _channel$notification : NotificationLevel.Mentions),
      onchange: e => this.saveNotifications(Number(e.target.value), null)
    }, m("option", {
      value: String(NotificationLevel.Always)
    }, app.translator.trans("ramon-chat.forum.info.level_always", {}, true)), m("option", {
      value: String(NotificationLevel.Mentions)
    }, app.translator.trans("ramon-chat.forum.info.level_mentions", {}, true)), m("option", {
      value: String(NotificationLevel.Never)
    }, app.translator.trans("ramon-chat.forum.info.level_never", {}, true)))), m("div", {
      className: "helpText"
    }, app.translator.trans(this.notificationLevelHelp(channel))), m(Switch, {
      state: Boolean(channel.isMuted()),
      onchange: value => this.saveNotifications(null, value),
      disabled: this.working
    }, app.translator.trans("ramon-chat.forum.info.mute")), m("div", {
      className: "helpText"
    }, app.translator.trans("ramon-chat.forum.info.mute_help"))), this.composerSection(), this.moderation());
  }

  /**
   * How this member's own composer behaves.
   *
   * Its own section rather than a row under NOTIFICATIONS, and worth being
   * explicit about why it is in a per-channel panel at all: which key sends is a
   * setting for the person, not for the channel, and it applies everywhere. The
   * section sits here because this is the panel a member already opens to adjust
   * the chat for themselves — but the help line says "every channel" so nobody
   * reads the surrounding modal as the scope.
   *
   * Guests never reach this: the chat requires an account, and `savePreferences`
   * needs a user to save against.
   */
  composerSection() {
    if (!app.session.user) return null;
    const preference = sendKeyPreference();
    return m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-section-label"
    }, app.translator.trans("ramon-chat.forum.info.composer")), m("label", null, app.translator.trans("ramon-chat.forum.info.send_key"), m("select", {
      className: "FormControl",
      value: preference,
      disabled: this.working,
      onchange: e => this.saveSendKey(e.target.value)
    }, m("option", {
      value: "enter"
    }, app.translator.trans("ramon-chat.forum.info.send_key_enter", {}, true)), m("option", {
      value: "ctrl"
    }, app.translator.trans("ramon-chat.forum.info.send_key_ctrl", {}, true)))), m("div", {
      className: "helpText"
    }, app.translator.trans(preference === "ctrl" ? "ramon-chat.forum.info.send_key_help_ctrl" : "ramon-chat.forum.info.send_key_help_enter")));
  }

  /** The line describing the notification level currently selected. */
  notificationLevelHelp(channel) {
    var _channel$notification2;
    switch ((_channel$notification2 = channel.notificationLevel()) != null ? _channel$notification2 : NotificationLevel.Mentions) {
      case NotificationLevel.Always:
        return "ramon-chat.forum.info.level_always_help";
      case NotificationLevel.Never:
        return "ramon-chat.forum.info.level_never_help";
      default:
        return "ramon-chat.forum.info.level_mentions_help";
    }
  }

  /**
   * Actions that change the channel for everyone. Each is drawn only when the
   * server said the actor may do it, so nothing here is present-and-rejected.
   */
  moderation() {
    const channel = this.attrs.channel;
    const items = [];
    if (channel.canClose()) {
      const closed = channel.status() === "closed";
      items.push(m(Button, {
        className: "Button",
        icon: closed ? "fas fa-lock-open" : "fas fa-lock",
        loading: this.working,
        onclick: () => this.setStatus(closed ? "open" : "closed")
      }, app.translator.trans(closed ? "ramon-chat.forum.info.reopen_channel" : "ramon-chat.forum.info.close_channel")));
    }
    if (channel.canArchive() && !channel.archivedAt()) {
      items.push(m(Button, {
        className: "Button",
        icon: "fas fa-box-archive",
        loading: this.working,
        onclick: () => this.archive()
      }, app.translator.trans("ramon-chat.forum.info.archive_channel")));
    }
    if (items.length === 0 && !channel.canDelete()) return null;
    return m('[', null, items.length > 0 ? m("div", {
      className: "ChatChannelInfo-section"
    }, items) : null, channel.canDelete() ? m("div", {
      className: "ChatChannelInfo-danger"
    }, m(Button, {
      className: "Button Button--text",
      icon: "fas fa-trash",
      onclick: () => this.destroy()
    }, app.translator.trans("ramon-chat.forum.info.delete_channel"))) : null);
  }

  // ── Members tab ────────────────────────────────────────────────────────────

  memberTab() {
    if (this.loadingMembers) {
      return m("div", {
        className: "ChatChannelInfo-section"
      }, MembersSkeleton());
    }
    const term = this.memberFilter.trim().toLowerCase();
    const shown = term ? this.members.filter(user => (user.displayName() + " " + user.username()).toLowerCase().includes(term)) : this.members;
    return m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-memberHeader"
    }, m("span", {
      className: "ChatChannelInfo-memberCount"
    }, app.translator.trans("ramon-chat.forum.channel.members", {
      count: this.members.length
    })), this.attrs.channel.canManageMembers() ? m(Button, {
      className: "Button Button--primary Button--compact",
      icon: "fas fa-user-plus",
      disabled: this.working,
      onclick: () => this.openAddMembers()
    }, app.translator.trans("ramon-chat.forum.add_members.title")) : null), m("input", {
      className: "FormControl ChatChannelInfo-filter",
      type: "search",
      placeholder: app.translator.trans("ramon-chat.forum.info.member_search", {}, true),
      value: this.memberFilter,
      oninput: e => {
        this.memberFilter = e.target.value;
      }
    }), m("div", {
      className: "ChatChannelInfo-memberList"
    }, shown.map(user => {
      var _app$session$user;
      return m("div", {
        key: user.id(),
        className: classList("ChatChannelInfo-member", {
          "ChatChannelInfo-member--online": isOnline(user)
        })
      }, m(Avatar, {
        user: user,
        className: "Avatar"
      }), m("span", null, userLink(user)), this.attrs.channel.canManageMembers() && user.id() !== ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) ? m(Button, {
        className: "Button Button--icon Button--flat ChatChannelInfo-member-remove",
        icon: "fas fa-user-minus",
        disabled: this.working,
        title: app.translator.trans("ramon-chat.forum.info.remove_member", {
          username: username(user)
        }, true),
        onclick: () => this.remove(user)
      }) : null);
    }), shown.length === 0 ? m("div", {
      className: "ChatBrowse-empty"
    }, app.translator.trans("ramon-chat.forum.info.no_members")) : null));
  }

  /**
   * Opens the people picker.
   *
   * Stacked on top of this modal rather than replacing it: the member list is
   * the context for the choice, and coming back to a closed dialog after adding
   * three people would mean reopening it to check they landed.
   *
   * This is how anyone gets into a private channel: it is not discoverable and
   * cannot be joined, so an existing member with `manageMembers` has to put you
   * there. Offered only when the server says the actor may — a moderator, or the
   * creator of a group conversation.
   */
  openAddMembers() {
    app.modal.show(AddMembersModal, {
      channel: this.attrs.channel,
      existing: this.members,
      onAdded: users => this.onMembersAdded(users)
    }, true);
  }

  /** Folds the picker's result into the list this tab is already showing. */
  onMembersAdded(users) {
    var _this$attrs$channel$u;
    const known = new Set(this.members.map(member => member.id()));
    const fresh = users.filter(user => !known.has(user.id()));
    if (fresh.length === 0) return;
    this.members = [...this.members, ...fresh];
    this.attrs.channel.pushAttributes({
      userCount: ((_this$attrs$channel$u = this.attrs.channel.userCount()) != null ? _this$attrs$channel$u : 0) + fresh.length
    });
    m.redraw();
  }

  /**
   * Removes someone else from the channel.
   *
   * Confirmed first: unlike adding, this one is not obviously undoable from the
   * other side — a private channel cannot be rejoined, so the person would have to
   * be added back by hand.
   */
  async remove(user) {
    const confirmed = confirm(app.translator.trans("ramon-chat.forum.info.remove_member_confirm", {
      username: username(user)
    }, true));
    if (!confirmed) return;
    this.working = true;
    m.redraw();
    try {
      var _this$attrs$channel$u2;
      const payload = await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(this.attrs.channel.id(), "/members/remove"),
        body: {
          data: {
            attributes: {
              userId: Number(user.id())
            }
          }
        }
      });
      if (payload != null && payload.data) app.store.pushPayload(payload);
      this.members = this.members.filter(member => member.id() !== user.id());

      // Kept in step with the server's own decrement so the count does not sit
      // one high until the next fetch.
      this.attrs.channel.pushAttributes({
        userCount: Math.max(0, ((_this$attrs$channel$u2 = this.attrs.channel.userCount()) != null ? _this$attrs$channel$u2 : 1) - 1)
      });
      app.alerts.show({
        type: "success"
      }, app.translator.trans("ramon-chat.forum.info.member_removed", {
        username: username(user)
      }));
    } catch (e) {
      var _e$response$errors$0$, _e$response;
      app.alerts.show({
        type: "error"
      }, (_e$response$errors$0$ = e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) != null ? _e$response$errors$0$ : app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async loadMembers() {
    if (this.loadedMembers || this.loadingMembers) return;
    this.loadingMembers = true;
    try {
      // Re-fetched with the relationship included rather than read off the
      // sidebar's copy, which is loaded without participants.
      const channel = await app.store.find("chat-channels", String(this.attrs.channel.id()), {
        include: "participants"
      });
      this.members = (channel.participants() || []).filter(Boolean);
    } catch (_unused) {
      this.members = [];
    } finally {
      this.loadingMembers = false;
      this.loadedMembers = true;
      m.redraw();
    }
  }

  // ── Actions ────────────────────────────────────────────────────────────────

  async saveNotifications(level, muted) {
    const channel = this.attrs.channel;

    // Optimistic: the endpoint answers 204, so there is nothing to push back and
    // waiting would leave the control visibly lagging the click.
    channel.pushAttributes(_objectSpread(_objectSpread({}, level !== null ? {
      notificationLevel: level
    } : {}), muted !== null ? {
      isMuted: muted
    } : {}));
    this.working = true;
    m.redraw();
    try {
      await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(channel.id(), "/notifications"),
        body: {
          data: {
            attributes: _objectSpread(_objectSpread({}, level !== null ? {
              notificationLevel: level
            } : {}), muted !== null ? {
              muted
            } : {})
          }
        }
      });
    } catch (_unused2) {
      app.alerts.show({
        type: "error"
      }, app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }

  /**
   * Stores the send-key choice on the user.
   *
   * Optimistic like `saveNotifications`, and for a sharper reason: the composer
   * reads the preference off the same record on every keystroke, so the change
   * has to be in place before the next one — waiting for the round trip would
   * mean the first Enter after choosing still did the old thing.
   *
   * The rollback is not the redundant belt-and-braces it looks like. `Model.save`
   * does snapshot and restore on failure, but `savePreferences` mutates the
   * preferences object *in place* before calling it, so the snapshot is taken
   * with the new value already in it and core's revert restores that. Undoing it
   * here is the only thing that stops a rejected save from leaving the select —
   * and the composer — agreeing with a server that never accepted it.
   */
  async saveSendKey(value) {
    const user = app.session.user;
    if (!user) return;
    const previous = sendKeyPreference();
    if (value === previous) return;
    this.working = true;
    try {
      await user.savePreferences({
        "ramon-chat.sendWithCtrlEnter": value
      });
    } catch (_unused3) {
      await user.savePreferences({
        "ramon-chat.sendWithCtrlEnter": previous
      }).catch(() => {});
      app.alerts.show({
        type: "error"
      }, app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async setStatus(status) {
    await this.act("/chat-channels/".concat(this.attrs.channel.id(), "/status"), {
      status
    });
  }
  async archive() {
    await this.act("/chat-channels/".concat(this.attrs.channel.id(), "/archive"), {});
  }
  async destroy() {
    if (!confirm(app.translator.trans("ramon-chat.forum.info.delete_confirm", {}, true))) return;
    this.working = true;
    try {
      await this.attrs.channel.delete();
      chatState.channels = chatState.channels.filter(c => c.id() !== this.attrs.channel.id());
      if (chatState.activeChannelId === Number(this.attrs.channel.id())) {
        chatState.setActiveChannel(null);
      }
      this.hide();
    } catch (_unused4) {
      app.alerts.show({
        type: "error"
      }, app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async act(path, attributes) {
    this.working = true;
    m.redraw();
    try {
      const payload = await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl")).concat(path),
        body: {
          data: {
            attributes
          }
        }
      });
      if (payload != null && payload.data) app.store.pushPayload(payload);
      this.hide();
    } catch (e) {
      var _e$response$errors$0$2, _e$response2;
      app.alerts.show({
        type: "error"
      }, (_e$response$errors$0$2 = e == null || (_e$response2 = e.response) == null || (_e$response2 = _e$response2.errors) == null || (_e$response2 = _e$response2[0]) == null ? void 0 : _e$response2.detail) != null ? _e$response$errors$0$2 : app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChannelInfoModal', ChannelInfoModal);